import { render } from "./DictionaryAbstract.vue?vue&type=template&id=daf8d2c2&scoped=true"
import script from "./DictionaryAbstract.vue?vue&type=script&lang=js"
export * from "./DictionaryAbstract.vue?vue&type=script&lang=js"

import "./DictionaryAbstract.vue?vue&type=style&index=0&id=daf8d2c2&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\web\\notigo_base\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf8d2c2"]])

export default __exports__